import { ApplicationBar, H2, SupportDropDown, getLocaleSwitch, useAuth, useDynamicConfig, useLocale } from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import styled from "styled-components";
import { ProfileDropdown } from "../../../shared/profile/ProfileDropdown";
import { GlobalContactViewSwitcher } from "../contactViews/global/GlobalContactViewSwitcher";
import { GlobalTenantSwitcher } from "../tenants/global/GlobalTenantSwitcher";

const Actions = styled.div`
	margin-left: auto;
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: max-content;
	gap: 0.5rem;
	height: 100%;
	align-items: center;
`;

const AppName = styled(H2)`
	font-size: 1.25rem;
	margin-bottom: 0;
	color: ${({ theme }) => theme.colors.applicationBar.text};
`;

const LocaleSwitch = getLocaleSwitch();

export const Header: FC = () => {
	const { logout } = useAuth();
	const { t } = useTranslation();
	const { languageSettings, profileUrl } = useDynamicConfig();
	const { language, setLanguage } = useLocale();
	const location = useLocation();

	const redirect = useMemo(() => {
		return window.location.href;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return (
		<ApplicationBar>
			<AppName>JARVIS</AppName>
			<Actions>
				<GlobalTenantSwitcher />
				<GlobalContactViewSwitcher />
				<LocaleSwitch
					availableLocales={languageSettings.availableLanguages}
					locale={language}
					setLocale={setLanguage}
				/>
				<SupportDropDown />
				<ProfileDropdown
					items={[
						{ type: "anchor", content: t("Profile"), href: `${profileUrl}?redirect=${redirect}` },
						{
							type: "link",
							to: "/user-preferences",
							content: t("Preferences"),
						},
						{ type: "button", content: t("Logout"), onClick: logout },
					]}
				/>
			</Actions>
		</ApplicationBar>
	);
};
